module.exports = __webpack_public_path__ + "img/ydj-email.66b9c62a.jpg";